import { render } from "./ProfileHeaderWithAdditionalData.vue?vue&type=template&id=3a8b6113&scoped=true"
import script from "./ProfileHeaderWithAdditionalData.vue?vue&type=script&lang=js"
export * from "./ProfileHeaderWithAdditionalData.vue?vue&type=script&lang=js"

import "./ProfileHeaderWithAdditionalData.vue?vue&type=style&index=0&id=3a8b6113&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a8b6113"]])

export default __exports__